import axios, { AxiosPromise, Canceler, CancelTokenStatic } from 'axios';
import { INorm } from '../../../@types/model/masterData/norm/norm';
import { INormUpsert } from '../../../@types/model/masterData/norm/normUpsert';

export default class NormHttpService {
    private static readonly CancelToken : CancelTokenStatic = axios.CancelToken;
    /**
     * Allows you to cancel list request
     */
    public static cancelGetList ?: Canceler;

    public static getList() : AxiosPromise<Array<INorm>> {
        if (this.cancelGetList) {
            this.cancelGetList('GET Canceled');
            this.cancelGetList = undefined;
        }

        return axios.get(`${API_URL}/v1/MasterData/Norm/GetList`, {
            cancelToken: new this.CancelToken((c) => {
                this.cancelGetList = c;
            }),
        });
    }

    public static upsert = (upsertList : Array<INormUpsert>, type : 'Add' | 'Edit') : AxiosPromise<Array<INorm>> => {
        return axios.post(`${API_URL}/v1/MasterData/Norm/${type}`, upsertList);
    }

    public static delete = (id : number) : AxiosPromise<INorm> => {
        return axios.delete(`${API_URL}/v1/MasterData/Norm/Delete`, {
            params: { id },
        });
    }
}